import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';
import fb from './fb.png';
import li from './in.png';
import yt from './yt.png';
import instagram from './ig-logo.png';
import logo from './track-logo-white .png';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
};


class Footer extends Component {

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        console.log(querystring)

        const language = querystring ? querystring : navigator.language;
    
        const currentLocale = locales[language] ? language : 'pt-BR';
    
        intl.init({
          currentLocale,
          locales
        });
      }

    render() {

        return (
            <footer className="footer-machine" itemScope="" itemType="http://schema.org/WPFooter" role="contentinfo">
                <div className="container">
                    <div className="row-machine">
                    <div className="col-12 col-sm-6 footer-menu d-flex align-items-center">
                        
                            <ul className="center">
                                
                            <a> <img alt="logo" width="180" src={logo}/>
                            </a>
                            </ul>
                        </div>
                        <div className="col-xs-12 col-sm-6 footer-menu d-flex align-items-center">
                            <div className="footer-links">
                                <ul className="menu list-unstyled">
                                    <li className="social">
                                    <li>
                                        <a href="http://track.co/blog" rel="noopener noreferrer" target="_blank" title="BLOG">BLOG</a>
                                    </li>
                                    {intl.get('footer.social')}<br />
                                    
                                        <a href="https://www.youtube.com/trackoficial" target="_blank">
                                            <img alt="youtube-track" width="30" src={yt}/>
                                        </a>
                                        <a href="https://linkedin.com/company/track-co" target="_blank">
                                            <img alt="linkedin-track" width="30" src={li}/>
                                        </a>
                                        <a href="https://www.facebook.com/trackcobr" target="_blank">
                                            <img alt="facebook-track" width="30" src={fb}/>
                                        </a>
                                        <a href="https://www.instagram.com/track.co/" target="_blank">
                                            <img alt="inst-track" width="30" src={instagram}/>
                                        </a>
                                    </li>
                                    
                                </ul>
                            </div>
                            <p className="copyright">
                                {intl.get('footer.copyright')}
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

        );
    }
}

export default Footer;